import type { SupabaseClient } from "@supabase/supabase-js";

/**
 * Lightweight query-builder type for the `workflow_conversations` table,
 * which isn't in the generated Supabase types yet.
 * Generic over <T> so each call-site can specify its own row shape.
 */

export interface WorkflowQueryResult<T> {
  data: T[] | null;
  count: number | null;
  error: { message?: string } | null;
}

export interface WorkflowQueryBuilder<T> extends PromiseLike<WorkflowQueryResult<T>> {
  select: (columns: string, options?: { count: "exact"; head: boolean }) => WorkflowQueryBuilder<T>;
  eq: (column: string, value: string) => WorkflowQueryBuilder<T>;
  in: (column: string, values: string[]) => WorkflowQueryBuilder<T>;
  not: (column: string, operator: string, value: null) => WorkflowQueryBuilder<T>;
  order: (column: string, options: { ascending: boolean }) => WorkflowQueryBuilder<T>;
  limit: (count: number) => WorkflowQueryBuilder<T>;
}

/** Cast helper — use until workflow_conversations is added to generated types. */
export function workflowQuery<T>(supabase: SupabaseClient): WorkflowQueryBuilder<T> {
  return (supabase.from as unknown as (table: string) => WorkflowQueryBuilder<T>)("workflow_conversations");
}
